import RoundIconLabelUnit from '@/components/ui/RoundIconLabelUnit/RoundIconLabelUnit';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatCurrency } from '@/utils/formatters';
import Link from 'next/link';
import { EcItemListItem, EcItemMessageType } from '../../types';
import EcItemThumbnail from '../EcItemThumbnail/EcItemThumbnail';
import EcItemTypeLabel from '../EcItemTypeLabel/EcItemTypeLabel';
import styles from './EcItemList.module.scss';

function EcItemList({
  ecItems,
  spLimit,
  pcLimit,
}: {
  ecItems: Array<EcItemListItem>;
  spLimit?: number;
  pcLimit?: number;
}) {
  const isSpLimitOver = (index: number) => {
    return spLimit && index + 1 > spLimit;
  };

  const isPcLimitOver = (index: number) => {
    return pcLimit && index + 1 > pcLimit;
  };

  return (
    <div className={styles.componentStyle}>
      {ecItems.map((ecItem, index) => (
        <Link
          key={`${ecItem.type}_${
            ecItem.isMessage ? EcItemMessageType.message.value : EcItemMessageType.general.value
          }_${ecItem.id}`}
          className={`${styles.itemContainer} ${isSpLimitOver(index) ? styles.spLimitOver : ''} ${
            isPcLimitOver(index) ? styles.pcLimitOver : ''
          }`}
          href={`/e-commerce/digital-contents/detail/${ecItem.productId}`}
          prefetch={false}
        >
          <div className={styles.imageContainer}>
            <EcItemThumbnail thumbnailUrl={ecItem.imageUrl} showWaterMark saleStatus={ecItem.status}></EcItemThumbnail>
          </div>
          <EcItemTypeLabel ecItemType={ecItem.type} hasMessage={ecItem.isMessage}></EcItemTypeLabel>
          <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold} ${styles.itemName}`}>{ecItem.name}</p>
          <RoundIconLabelUnit
            iconImageUrl={ecItem.bizCreatorImageUrl}
            labelText={ecItem.bizCreatorName}
            size='small'
          ></RoundIconLabelUnit>
          <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>
            ¥{formatCurrency(ecItem.taxIncludedPrice)}
          </p>
        </Link>
      ))}
    </div>
  );
}

export default EcItemList;
